import type { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import { manifest as engagementSurveysManifest } from 'modules/engagement_surveys/lib/manifest'
import { manifest as financeManifest } from 'modules/finance/lib/manifest'
import { manifest as itManagementManifest } from 'modules/it_management/lib/manifest'
import { manifest as operationsManifest } from 'modules/operations/lib/manifest'
import { manifest as talentManifest } from 'modules/talent/lib/manifest'

import { manifest as coreManifest } from './index'

export const manifests = {
  core: coreManifest,
  operations: operationsManifest,
  finance: financeManifest,
  talent: talentManifest,
  it_management: itManagementManifest,
  engagement_surveys: engagementSurveysManifest,
}

export const sidebarInfo = (navigation: Navigation<NavigationPaths>) => {
  return Object.values(manifests).flatMap(
    (moduleManifest) => moduleManifest.sidebar(navigation).items
  )
}

export type ManifestsType = typeof manifests
